module.exports = __webpack_public_path__ + "img/snow_fall_00013.75c42a53.png";